import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { calendarRegisterList } from "../../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";
import { memo, useCallback, useEffect, useMemo, useState } from "react";

interface IDaysAheadCalendarsProps {
  automationCode: string;
}

const TASY_SCHEDULE_TYPE_CODE = [3];

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedDaysAhead.";

export const DaysAheadCalendars = memo(
  ({ automationCode }: IDaysAheadCalendarsProps) => {
    const { t } = useTranslation();

    const { sendRequest } = useFetch(calendarRegisterList);

    const [
      optionsTicketAutomationReceivedDaysAheadCalendars,
      setTicketAutomationReceivedDaysAheadCalendars,
    ] = useState<ISelectType[]>([]);

    const classificationConsultationIdentifier = useMemo(() => {
      if (!automationCode) return;

      return automationCode === "25" ? ["R"] : null;
    }, [automationCode]);

    const params = useMemo(() => {
      return {
        EnableCode: true,
        TasyScheduleTypeCode: TASY_SCHEDULE_TYPE_CODE,
        ClassificationConsultationIdentifier:
          classificationConsultationIdentifier,
      };
    }, [classificationConsultationIdentifier]);

    const fetchTicketAutomationReceivedDaysAheadCalendars =
      useCallback(async () => {
        const { data, success } = await sendRequest(params);

        if (data && success) {
          const isType3Selected =
            Array.isArray(TASY_SCHEDULE_TYPE_CODE) &&
            TASY_SCHEDULE_TYPE_CODE.includes(3);

          setTicketAutomationReceivedDaysAheadCalendars(
            data.map((d) => {
              const titleBase = isType3Selected
                ? (d.descriptionSite ?? d.calendarName)
                : d.calendarName;

              return {
                id: String(d.identifier),
                name: `${titleBase} - ${d.identifier}`,
              };
            }),
          );
        }
      }, [sendRequest, params]);

    useEffect(() => {
      fetchTicketAutomationReceivedDaysAheadCalendars();
    }, [fetchTicketAutomationReceivedDaysAheadCalendars]);

    return (
      <Grid item xs={12} sm={5}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          options={optionsTicketAutomationReceivedDaysAheadCalendars}
          name="ticketAutomationReceivedDaysAheadCalendars"
          label={t(
            translationPath + "ticketAutomationReceivedDaysAheadCalendars",
          )}
          getOptionLabel={(option) => option.name}
          size="small"
          keepOpenOnSelect={true}
        />
      </Grid>
    );
  },
);
